<template>
  <div>
    <div class="mb-4">
      <b-row>
        <b-col xl="8" lg="10" md="12">
          <!-- Nome do plano de viagem -->
          <b-form-group
            :label="$t('tripPlan.nameFull')"
            label-for="input-process-displayName"
          >
            <b-form-input
              id="input-form-name"
              type="text"
              v-model="model.name"
              required
              :placeholder="$t('tripPlan.nameFull')"
            >
            </b-form-input>
            <span class="text-danger" v-if="modelstate['Name']">
              {{ modelstate["Name"][0] }}
            </span>
          </b-form-group>

          <!-- Tempo total (digitado) -->
          <b-form-group
            :label="$t('tripPlan.totalTimeEntered')"
            label-for="totalTimeEntered"
          >
            <input-seconds-as-time
              id="totalTimeEntered"
              :seconds.sync="model.totalSecondsEntered"
            >
            </input-seconds-as-time>
            <span class="text-danger" v-if="modelstate['TotalSecondsEntered']">
              {{ modelstate["TotalSecondsEntered"][0] }}
            </span>
          </b-form-group>

          <!-- Valor pago ao motorista -->
          <b-form-group
            :label="$t('tripPlan.costs.paidToDriver')"
            label-for="ValuePaidToDriver"
          >
            <base-input-numeric
              id="ValuePaidToDriver"
              :placeholder="$t('tripPlan.costs.paidToDriver')"
              :value.sync="model.valuePaidToDriver"
            >
            </base-input-numeric>
            <span class="text-danger" v-if="modelstate['ValuePaidToDriver']">
              {{ modelstate["ValuePaidToDriver"][0] }}
            </span>
          </b-form-group>

          <!-- Valor do frete -->
          <b-form-group
            :label="$t('tripPlan.costs.freight')"
            label-for="ValueFreight"
          >
            <base-input-numeric
              id="valuePaidToDriver"
              :placeholder="$t('tripPlan.costs.freight')"
              :value.sync="model.valueFreight"
            >
            </base-input-numeric>
            <span class="text-danger" v-if="modelstate['ValueFreight']">
              {{ modelstate["ValueFreight"][0] }}
            </span>
          </b-form-group>

          <!-- Imposto -->
          <b-form-group :label="$t('tripPlan.costs.tax')" label-for="Tax">
            <base-input-numeric
              id="Tax"
              :placeholder="$t('tripPlan.costs.tax')"
              :value.sync="model.tax"
            >
            </base-input-numeric>
            <span class="text-danger" v-if="modelstate['Tax']">
              {{ modelstate["Tax"][0] }}
            </span>
          </b-form-group>

          <!-- Valor de comissão -->
          <b-form-group
            :label="$t('tripPlan.costs.commission')"
            label-for="ValueCommission"
          >
            <base-input-numeric
              id="ValueCommission"
              :placeholder="$t('tripPlan.costs.commission')"
              :value.sync="model.valueCommission"
            >
            </base-input-numeric>
            <span class="text-danger" v-if="modelstate['ValueCommission']">
              {{ modelstate["ValueCommission"][0] }}
            </span>
          </b-form-group>

          <!-- Aluguel de carreta -->
          <b-form-group
            :label="$t('tripPlan.costs.truckRental')"
            label-for="ValueTruckRental"
          >
            <base-input-numeric
              id="ValueTruckRental"
              :placeholder="$t('tripPlan.costs.truckRental')"
              :value.sync="model.valueTruckRental"
            >
            </base-input-numeric>
            <span class="text-danger" v-if="modelstate['ValueTruckRental']">
              {{ modelstate["ValueTruckRental"][0] }}
            </span>
          </b-form-group>

          <b-row>
            <b-col>
              <!-- emitir documento -->
              <b-form-group
                :label="$t('tripPlan.costs.issueDocument')"
                label-for="issueDocument"
              >
                <b-form-select
                  v-model="model.issueDocument"
                  id="issueDocument"
                  :options="booleanOpt"
                >
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <!-- CTE averbada -->
              <b-form-group
                :label="$t('tripPlan.costs.CTEWillBeEndorsed')"
                label-for="cteWillBeEndorsed"
              >
                <b-form-select
                  v-model="model.cteWillBeEndorsed"
                  id="cteWillBeEndorsed"
                  :options="booleanOpt"
                >
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <!-- Tipo de deslocamento -->
              <b-form-group
                id="DisplacementType"
                :label="'Tipo de deslocamento:'"
              >
                <b-form-select
                  v-model="model.displacementType"
                  id="DisplacementType"
                  :options="options"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <label for="">{{ $t("tripPlan.definePath") }}:</label>

    <div v-if="mapEngine === '0'">
      <leaflet-map ref="map" id="map">
        <leaflet-route
          ref="map2"
          v-if="getWaypointActive && getWaypointActive.length > 0"
          @calculateDirections="calculateDirections"
        >
          <leaflet-waypoint
            v-for="waypoint in getWaypointActive"
            :key="waypoint.sequenceNumber"
            :latitude="waypoint.latitude"
            :longitude="waypoint.longitude"
          ></leaflet-waypoint>
        </leaflet-route>
        <div
          v-for="waypoint in availableWaypoints"
          :key="waypoint.sequenceNumber"
        >
          <leaflet-marker
            v-if="isWaypointUsed(waypoint.id)"
            :latitude="waypoint.latitude"
            :longitude="waypoint.longitude"
            marker-style="invisible"
          />
          <leaflet-marker
            v-else
            :latitude="waypoint.latitude"
            :longitude="waypoint.longitude"
            marker-style="secondary"
            @onClick="onSelectMarker"
          ></leaflet-marker>
        </div>
      </leaflet-map>
    </div>

    <div v-if="mapEngine === '1'">
      <google-map
        style="height: 900px; width: 1600px; max-width: 100%; max-height: 100%;"
        ref="map3"
      >
        <google-map-marker
          v-for="(waypoint, index) in filteredWaypoints"
          :key="'marker-' + (waypoint.sequenceNumber || index)"
          :position="{ lat: waypoint.latitude, lng: waypoint.longitude }"
          @marker-clicked="handleMarkerClicked"
          @render-waypoints="handleRenderWaypoints"
        />
        <template v-if="renderWaypoints">
          <google-map-route
            v-if="getWaypointActive && getWaypointActive.length > 0"
            :waypoints="getWaypointActive"
            @calculateDirections="calculateDirections"
          >
            <google-map-waypoint
              v-for="waypoint in getWaypointActive"
              :key="'waypoint-' + waypoint.sequenceNumber"
              :position="{ lat: waypoint.latitude, lng: waypoint.longitude }"
              :sequenceNumber="waypoint.sequenceNumber"
              :totalWaypoints="getWaypointActive.length"
              style="position: absolute; z-index: 999;"
            />
          </google-map-route>
        </template>
      </google-map>
    </div>

    <b-button size="sm" @click="addWaypoint()">{{
      $t("tripPlan.addDestiny")
    }}</b-button>
    <!-- <pre class="language-json"><code>getWaypointActive: {{ getWaypointActive  }}</code></pre> -->
    <!-- <pre class="language-json" ><code>availableWaypoints: {{ availableWaypoints  }}</code></pre> -->
    <!-- <pre class="language-json"><code>getAvailableWaypoints: {{ getAvailableWaypoints  }}</code></pre> -->
    <b-table
      ref="MyForm"
      class="table-nowrap"
      :items="getWaypointActive"
      :fields="fields"
    >
      <template v-slot:cell(actions)="data">
        <!-- {{ data.item }} -->
        <b-button
          size="sm"
          :title="$t('tripPlan.editWaypoint')"
          v-b-tooltip.hover
          @click="editWaypointPosition(data.item)"
        >
          <i class="tim-icons icon-pencil"> </i>
        </b-button>
        <b-button
          class="ml-1"
          size="sm"
          :title="$t('tripPlan.deleteWaypoint')"
          v-b-tooltip.hover
          @click="deleteWaypoint(data.item)"
        >
          X
        </b-button>
        <waypoint-resequence
          class="d-inline ml-1"
          :item="data.item"
          :items="model.waypoints"
          :display-name="data.item.name"
          :title="$t('checklist.form.fieldResequence')"
          v-b-tooltip.hover
          @onResequenceDone="onResequenceDone"
        ></waypoint-resequence>
      </template>
    </b-table>
    <!-- <b-row>
      <b-col>
        <b-button @click="capturarMapDiv" size="sm">
          Capturar imagem mapa
        </b-button>

        <b-button @click="downloadMapDiv" size="sm" class="ml-2">
          Download imagem mapa
        </b-button>
      </b-col>
    </b-row> -->
    <span class="text-danger" v-if="modelstate['ImagePath']">
      {{ modelstate["ImagePath"][0] }}
    </span>
    <!-- </div> -->
    <b-row>
      <b-col class="imageMap">
        <img :src="model.imagePath" />
      </b-col>
    </b-row>
    <path-add-waypoint
      ref="waypoint"
      :points="model.waypoints"
      :item.sync="item"
    ></path-add-waypoint>
    <!-- <pre class="language-json"><code>{{ model  }}</code></pre> -->
  </div>
</template>
<script>
import AwesomeMask from "awesome-mask";
import html2canvas from "html2canvas";
import WaypointResequenceMixin from "@/mixins/tripPlan/WaypointResequenceMixin.js";
import BaseInputNumeric from "@/components_rms/base/BaseInputNumeric.vue";
import InputSecondsAsTime from "@/components_rms/base/InputSecondsAsTime.vue";

export default {
  name: "PathCrud",
  components: {
    InputSecondsAsTime,
    GoogleMap: () => import("@/components_rms/base/googlemaps/GoogleMap.vue"),
    GoogleMapMarker: () =>
      import("@/components_rms/base/googlemaps/GoogleMapMarker.vue"),
    BaseInputNumeric: () =>
      import("@/components_rms/base/BaseInputNumeric.vue"),
    GoogleMapWaypoint: () =>
      import("@/components_rms/base/googlemaps/GoogleMapWaypoint.vue"),
    GoogleMapRoute: () =>
      import("@/components_rms/base/googlemaps/GoogleMapRoute.vue"),
    LeafletMap: () => import("@/components_rms/base/leaflet/LeafletMap.vue"),
    LeafletMarker: () =>
      import("@/components_rms/base/leaflet/LeafletMarker.vue"),
    LeafletRoute: () =>
      import("@/components_rms/base/leaflet/LeafletRoute.vue"),
    LeafletWaypoint: () =>
      import("@/components_rms/base/leaflet/LeafletWaypoint.vue"),
    WaypointResequence: () =>
      import("@/components_rms/workflow/Path/WaypointResequence.vue"),
    PathAddWaypoint: () =>
      import("@/components_rms/workflow/Path/PathAddWaypoint.vue")
  },
  directives: {
    mask: AwesomeMask
  },
  mixins: [WaypointResequenceMixin],
  props: {
    model: Object,
    modelstate: Object,
    isEdit: Boolean
  },
  data() {
    return {
      mapEngine: localStorage.getItem("mapEngine"),
      renderWaypoints: false,
      availableWaypoints: [],
      markerCrud: null,
      mapImgSource: null,
      item: {},
      options: [
        { value: 1, text: "Viagem (paga)" },
        { value: 2, text: "Deslocamento vazio" }
      ],
      fields: [
        {
          key: "actions",
          filterKey: "actions",
          sortable: false,
          label: "",
          tdClass: "tableActions"
        },
        {
          key: "sequenceNumber",
          label: "Seq",
          sortable: false,
          thStyle: "min-width: 50px;"
        },
        {
          key: "name",
          sortable: false,
          label: "Nome",
          thStyle: "min-width: 200px;"
        },
        {
          key: "fullAddress",
          sortable: false,
          label: "Endereço",
          thStyle: "min-width: 200px;"
        },
        {
          key: "tripPlanWaypointsType",
          sortable: false,
          label: "Operação",
          thStyle: "min-width: 200px;",
          formatter: (value, key, item) => {
            if (value == 1) return "COLETA";
            if (value == 2) return "PARADA AUTORIZADA";
            if (value == 3) return "DESCANSO RECOMENDADO";
            if (value == 4) return "ENTREGA";
          }
        },
        {
          key: "distance",
          sortable: false,
          label: "Distância",
          tdClass: "table-col-dinamic-width"
        },
        {
          key: "secondsTravel",
          sortable: false,
          label: "Tempo deslocamento",
          tdClass: "table-col-dinamic-width",
          formatter: (value, key, item) => {
            return this.secondsToHHHmm(value);
          }
        },
        {
          key: "secondsStay",
          sortable: false,
          label: "Tempo permanencia ",
          tdClass: "table-col-dinamic-width",
          formatter: (value, key, item) => {
            return this.secondsToHHHmm(value);
          }
        },
        {
          key: "secondsAdditional",
          sortable: false,
          label: "Tempo adicional",
          tdClass: "table-col-dinamic-width",
          formatter: (value, key, item) => {
            return this.secondsToHHHmm(value);
          }
        },
        {
          key: "latitude",
          sortable: false,
          label: "Latitude",
          tdClass: "table-col-dinamic-width"
        },
        {
          key: "longitude",
          sortable: false,
          label: "Longitude",
          tdClass: "table-col-dinamic-width"
        }
      ],
      booleanOpt: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" }
      ]
    };
  },
  mounted() {
    this.loadActiveWaypoints();
  },
  computed: {
    filteredWaypoints() {
      return this.availableWaypoints.filter(
        waypoint => !this.isWaypointUsed(waypoint.id)
      );
    },
    getAvailableWaypoints() {
      if (!this.availableWaypoints) return [];

      let activeWaypoints = this.getWaypointActive;
      if (!activeWaypoints) return [];

      let unusedWaypoints = [];
      for (let availableWaypoint of this.availableWaypoints) {
        let isUsed = false;
        for (let activeWaypoint of activeWaypoints) {
          if (availableWaypoint.id == activeWaypoint.waypointId) {
            isUsed = true;
          }
        }
        if (!isUsed) {
          unusedWaypoints.push(availableWaypoint);
        }
      }
      return unusedWaypoints;
    },
    getSortedWaypoints() {
      if (!this.model) return [];
      if (!this.model.waypoints) return [];
      return this.getSortedList(this.model.waypoints);
    },
    getWaypointActive() {
      if (!this.model) return [];
      if (!this.model.waypoints) return [];
      let waypointActive = [];
      for (let w of this.model.waypoints) {
        if (w.active) {
          waypointActive.push(w);
        }
      }
      return waypointActive.sort(
        (c1, c2) => c1.sequenceNumber - c2.sequenceNumber
      );
    }
  },
  methods: {
    fitBounds() {
      const mapObject = this.$refs.map3;
      if (mapObject) {
        const bounds = new google.maps.LatLngBounds();
        let waypoints = this.getWaypointActive;
        for (let activeWaypoint of waypoints) {
          bounds.extend(
            new google.maps.LatLng(
              activeWaypoint.latitude,
              activeWaypoint.longitude
            )
          );
        }
        mapObject.fitBounds(bounds);
      } else {
        console.error("Map object is undefined.");
      }
    },
    handleRenderWaypoints(renderWaypoints) {
      this.renderWaypoints = renderWaypoints;
    },
    isWaypointUsed(waypointId) {
      for (let activeWaypoint of this.getWaypointActive) {
        if (waypointId == activeWaypoint.waypointId) {
          return true;
        }
      }
      return false;
    },
    handleMarkerClicked(position) {
      const clickedWaypoint = this.availableWaypoints.find(
        waypoint =>
          waypoint.latitude === position.lat &&
          waypoint.longitude === position.lng
      );

      if (clickedWaypoint) {
        this.item = {};
        this.$refs.waypoint.showLatLng(
          clickedWaypoint.latitude,
          clickedWaypoint.longitude
        );
      } else {
        this.item = {};
        console.log(
          "Nenhum waypoint encontrado para as coordenadas clicadas:",
          position
        );
      }
    },
    loadActiveWaypoints() {
      this.$apiWorkflow
        .get("/waypoint/all/")
        .then(response => {
          this.availableWaypoints = response.data;
        })
        .catch(error => {
          console.log("PathAddWaypoint.getWaypointOpt()");
          console.log(error);
          this.availableWaypoints = [];
        });
    },
    formaterDay(secunds) {
      if (secunds < 3600) return secunds / 60;
      else return secunds / 3600;
    },
    addWaypoint() {
      this.item = {};
      this.$refs.waypoint.show();
    },
    editWaypointPosition(point) {
      this.item = point;
      this.$refs.waypoint.show(point);
    },
    deleteWaypoint(waypoint) {
      if (waypoint.id == 0) {
        let indexToRemove = this.model.waypoints.indexOf(waypoint);
        this.model.waypoints.splice(indexToRemove, 1);
      } else {
        this.model.waypoints.forEach(point => {
          if (point.id == waypoint.id) point.active = false;
        });
      }
      // this.$refs.map2.spliceWaypoints(waypoint.latitude, waypoint.longitude);
      let sortedWaypoints = this.getWaypointActive;
      for (let i = 0; i < sortedWaypoints.length; i++) {
        let sortedWaypoint = sortedWaypoints[i];
        sortedWaypoint.sequenceNumber = i + 1;
      }
      this.$refs.map.forceUpdate();
      this.$refs.MyForm.refresh();

      // let routeWaypoint = this.$refs.map2.getWaypoint(
      //   waypoint.latitude,
      //   waypoint.longitude
      // );
      // if (routeWaypoint) {
      //   this.$refs.map2.spliceWaypoint(routeWaypoint);
      //   if (waypoint.id == 0) {
      //     let indexToRemove = this.model.waypoints.indexOf(waypoint);
      //     this.model.waypoints.splice(indexToRemove, 1);
      //   } else {
      //     this.model.waypoints.forEach((point) => {
      //       if (point.id == waypoint.id) point.active = false;
      //     });
      //   }
      //   // this.$refs.map2.spliceWaypoints(waypoint.latitude, waypoint.longitude);
      //   let sortedWaypoints = this.getWaypointActive;
      //   for (let i = 0; i < sortedWaypoints.length; i++) {
      //     let sortedWaypoint = sortedWaypoints[i];
      //     sortedWaypoint.sequenceNumber = i + 1;
      //   }
      //   this.$refs.MyForm.refresh();
      // }
    },
    async calculateDirections(routeLegs) {
      this.fitBounds();
      if (this.model.waypoints.length == 0) return;
      let waypoints = this.getWaypointActive;
      let firstWaypoint = waypoints[0];
      firstWaypoint.distance = 0.0;
      firstWaypoint.secondsTravel = 0;

      for (let i = 1; i < waypoints.length; i++) {
        let waypoint = waypoints[i];
        let leg = routeLegs[i - 1];
        waypoint.latitude = leg.endWaypoint.latitude;
        waypoint.longitude = leg.endWaypoint.longitude;
        waypoint.distance = leg.summary.distance;
        waypoint.secondsTravel = leg.summary.time;
      }
    },

    async capturarMapDiv() {
      const canvas = await this.$refs.map.exportMapCanvas();
      const myImage = canvas.toDataURL();
      this.mapImgSource = myImage;
      this.model.imagePath = myImage;
    },
    async downloadMapDiv() {
      // await this.$refs.map.exportMapCanvas();
      const canvas = await this.$refs.map.exportMapCanvas();
      const myImage = canvas.toDataURL();
      this.downloadURI(myImage, "MaSimulation.png");
    },
    downloadURI(uri, name) {
      var link = document.createElement("a");
      link.download = name;
      link.href = uri;
      document.body.appendChild(link);
      link.click();
      //after creating link you should delete dynamic link
      //clearDynamicLink(link);
    },

    onSelectMarker(e) {
      let clickedWaypoint = null;
      for (let w of this.availableWaypoints) {
        if (w.latitude == e.latlng.lat && w.longitude == e.latlng.lng) {
          clickedWaypoint = w;
        }
      }
      if (clickedWaypoint) {
        this.item = {};
        this.$refs.waypoint.showLatLng(
          clickedWaypoint.latitude,
          clickedWaypoint.longitude
        );
      } else {
        this.item = {};
        this.$refs.waypoint.show();
      }
    },
    onResequenceDone() {
      this.$refs.map2.forceUpdate();
    }
  },
  watch: {
    model(newValue, oldValue) {
      if (!this.model) return;
      this.totalTimeEntered = this.secondsToHHHmm(
        this.model.totalSecondsEntered
      );
    }
  }
};
</script>
<style scoped>
.imageMap {
  width: 25% !important;
}
</style>
